export const DropdownIcon: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M18.1599 7.88L11.9999 14L5.83994 7.88C5.74698 7.78627 5.63638 7.71187 5.51452 7.6611C5.39266 7.61034 5.26196 7.5842 5.12994 7.5842C4.99793 7.5842 4.86723 7.61034 4.74537 7.6611C4.62351 7.71187 4.51291 7.78627 4.41994 7.88C4.23369 8.06736 4.12915 8.32081 4.12915 8.585C4.12915 8.84918 4.23369 9.10263 4.41994 9.29L11.2599 16.12C11.4446 16.3084 11.6962 16.4162 11.9599 16.42H11.9999C12.2637 16.4162 12.5153 16.3084 12.6999 16.12L19.5399 9.29C19.7262 9.10263 19.8307 8.84918 19.8307 8.585C19.8307 8.32081 19.7262 8.06736 19.5399 7.88C19.354 7.70271 19.1069 7.60381 18.8499 7.60381C18.593 7.60381 18.3459 7.70271 18.1599 7.88Z"
        fill="var(--inzeloop-ds-color-action-primary-pressed)"
      />
    </svg>
  );
};
